import React from 'react'
import { ResultItem } from './instant_result_item'
import { groups, usersResult } from './mock'

export const InstantResult = ({q}) => {
    return (
        <div className="results">
             <h1>{q}</h1>
            {groups.map(group=>(
                <div key={group} className="group">
                     <div key={group}>
                        <div>{group}</div>
                        <ul>
                            {usersResult.map(item=>(<React.Fragment><ResultItem item={item} /></React.Fragment>))}
                        </ul>
                    </div>
                </div>
            ))}
        </div>
    )
}